<template>
	<div>
		<headinfo :islogin="islogins"></headinfo>
		<!--中间内容-->
		<div class="center container">
			<div class="center-nav">
				<span class="hidden-xs">您的位置：</span>
				<a href="/index.html">首页</a><i>&gt;</i>
				<a title="网上服务" href="#">网上服务</a>
			</div>
			<div class="center-container">
				<div class="center-container-left">
					<div class="center-container-left-Ltitle">
						<ul>
							<li>
								<a class="active" title="网上咨询" @click="show('1')">网上咨询</a>
							</li>
							<li>
								<a class="active" title="网上咨询" @click="show('2')">网上预约</a>
							</li>
							<li>
								<a class="active" title="网上咨询" @click="show('3')">网上申办</a>
							</li>
						</ul>
						<div class="left-pic">
							<img src="./../assets/img/left-pic.png" alt="">
						</div>
					</div>
				</div>
				<div class="center-container-right" v-if="pages=='1'">
					<div class="center-container-right-title">
						<span class="title">网上咨询</span>
					</div>
					<div class="center-container-right-words">
						<div class="people-pic">
							<div class="form_box" v-if="show1">
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
									class="demo-ruleForm">
									<el-form-item label="姓  名" prop="name">
										<el-input placeholder="请输入您的姓名" v-model="ruleForm.name"></el-input>
									</el-form-item>
									<el-form-item label="手机号码" prop="phone">
										<el-input placeholder="请输入您的手机号码" v-model="ruleForm.phone"></el-input>
									</el-form-item>
									<el-form-item label="咨询内容" prop="content">
										<el-input rows="10" placeholder="请输入您需要咨询的问题" type="textarea"
											v-model="ruleForm.content"></el-input>
									</el-form-item>
									<el-form-item label="是否公开" prop="ispublic">
										<el-radio-group v-model="ruleForm.ispublic">
											<el-radio :label="true">公开</el-radio>
											<el-radio :label="false">不公开</el-radio>
										</el-radio-group>
									</el-form-item>

									<el-form-item style="text-align: center;margin-top: 30px;">
										<el-button @click="sendsetWebConsulting" type="danger">提交咨询</el-button>
									</el-form-item>
								</el-form>
							</div>
							<div class="form_box" v-if="!show1">
								<el-result icon="success" title="提交成功" subTitle="您的咨询提交成功,请耐心等待公证员回复!">
								</el-result>
							</div>
						</div>
					</div>
				</div>

				<!-- 网上预约 -->
				<div class="center-container-right" v-if="pages=='2'">
					<div class="center-container-right-title">
						<span class="title">网上预约</span>
					</div>
					<div class="center-container-right-words">
						<div class="people-pic">
							<div class="form_box" v-if="show2">
								<div>
									<el-row :gutter="15">
										<div v-if="!isinform">
											<div style="height: 600px;line-height: 30px;padding: 20px 30px;overflow: scroll; ">
												公证申请人：</br>
												依据《公证法》第二十七条第二款的规定，现将你申办公证的法律意义、法律后果以及申办公证的注意事项告知如下：</br>
												1．在办理公证过程中，本处工作人员会以下列方式（之一或者全部）搜集和固定你对申请公证的事项进行陈述、确认的证明材料：</br>
												  （1）请你在相关的文件上签字；</br>
												  （2）请你在相关的文件上按指印；</br>
												  （3）提取你的全部指纹；</br>
												  （4）对你办理公证的某些过程进行拍照；</br>
												  （5）对你办理公证的某些过程进行录像；</br>
												  （6）对你办理公证的某些过程进行录音。</br>
												本处将上述证明材料的全部或者部分作为本处出具公证书的依据予以存档。因此，对于需要你在本处签字（按指印）确认的文件，请你在签字（按指印）前务必仔细阅读。如果你存在异议，请勿签字（按指印）。如果你不能阅读，你可以请求公证员向你宣读和解释需要你签字（按指印）确认的全部文件。</br>
												本次申办为网上在线申办，申请人需承诺该公证申请完全出自本人意愿，同意公证处线上办证平台对其身份核验（活体检测）、远程视频核验，保证其电子签名真实且字迹清晰可辨。</br></br>
												2．你的申请被受理后，经过公证员审核，如果发现你所申请的事项存在法律规定的不予办理公证的情形，本处将不予出具公证书。</br>
												3．在申办公证的过程中，你主要享有以下权利：</br>
												  （1）在办证过程中，你对办理公证的相关材料的内容和办理公证的法律意义、法律后果有不清楚之处，你有权要求公证员进行告知和解释；</br>
												  （2）你在询问笔录上签字（按指印）之前，你有权要求公证员修改询问笔录，并对笔录和笔录的修改之处签字（按指印）确认。</br>
												4．在申办公证的过程中，你主要应当承担以下义务：</br>
												你有义务向本处作如实的陈述和提供真实、合法、充分的证明材料。如果你不能作如实陈述以及不能提供真实、合法、充分的证明材料，依据《公证程序规则》第四十八条第（六）项的规定，本处不予办理公证。如果因为你所作的陈述不真实，或者提供的材料虚假，本处有权拒绝出具公证书，或者撤销已经出具的公证书，并有权要求你承担相应的法律责任。</br>
												5．在本处出具公证书后，你认为公证书有错误的，有权在收到公证书之日起一年内，向本公证处提出复查，超过一年复查申请期限的，本处不再受理你的复查申请。</br></br>
												本处特别提示：请你在前面告知书上签字（按指印）之前务必认真阅读本告知书。如果你有疑问或者异议，可以要求本处工作人员作出解答；如果你阅读本告知书有困难，可以要求本处工作人员向你宣读。经你签字确认后，本告知书将存入本处的公证档案，作为你已经知悉本告知书所载明内容，并愿意承担相应义务的证据。
											</div>
											<el-col :span="24" style="text-align: center;margin-top: 20px;">
													<el-button type="danger" @click="inform" >已阅读并同意上述告知</el-button>
											</el-col>
										</div>
										<el-form v-if="isinform" class="demo-ruleForm" ref="yruleForm" :model="yruleForm"
											:rules="yrules" size="medium" label-width="100px">
											<el-col :span="12">
												<el-form-item label="姓名" prop="name">
													<el-input placeholder="请输入您的姓名" v-model="yruleForm.name"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="12">
												<el-form-item label="手机号码" prop="phone">
													<el-input placeholder="请输入您的手机号码" v-model="yruleForm.phone">
													</el-input>
												</el-form-item>
											</el-col>
											<el-col :span="12">
												<el-form-item label="预约日期" prop="appointmentdate">
													<el-date-picker v-model="yruleForm.appointmentdate" type="datetime"
														placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"
														key="day" style="width: 100%;">
													</el-date-picker>
												</el-form-item>
											</el-col>
											<el-col :span="12">
												<el-form-item label="公证类别" prop="category">
													<el-select @change="lbchange" v-model="yruleForm.category"
														placeholder="请选择公证类别" clearable :style="{width: '100%'}">
														<el-option v-for="(item, index) in lboptions" :key="index"
															:label="item.value" :value="item.key"
															:disabled="item.disabled"></el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="12">
												<el-form-item label="公证用途" prop="purpose">
													<el-select v-model="yruleForm.purpose" placeholder="请选择公证用途"
														clearable :style="{width: '100%'}">
														<el-option v-for="(item, index) in ytoptions" :key="index"
															:label="item.value" :value="item.value"
															:disabled="item.disabled"></el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="12">
												<el-form-item label="公证使用地" prop="place">
													<el-select @visible-change="sydchange" v-model="yruleForm.place"
														placeholder="请选择公证使用地" clearable :style="{width: '100%'}">
														<el-option v-for="(item, index) in sydoptions" :key="index"
															:label="item.value" :value="item.value"
															:disabled="item.disabled"></el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="24">
												<el-form-item label="公证事项" prop="matter">
													<el-select @visible-change="sxchange" v-model="yruleForm.matter"
														placeholder="请选择公证事项" clearable :style="{width: '100%'}">
														<el-option v-for="(item, index) in sxoptions" :key="index"
															:label="item.name" :value="item.name"
															:disabled="item.disabled"></el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="24">
												<el-form-item label="预约描述" prop="content">
													<el-input rows="5" placeholder="请简要描述您需要预约的公证情况" type="textarea"
														v-model="yruleForm.content"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="24">
												<el-form-item size="large" style="text-align: center;margin-top: 30px;">
													<el-button type="danger" @click="addyy('yruleForm')">提交预约
													</el-button>
												</el-form-item>
											</el-col>
										</el-form>
									</el-row>
								</div>
							</div>
							<div class="form_box" v-if="!show2">
								<el-result icon="success" title="提交成功" subTitle="您的预约提交成功,请耐心等待公证员审核!">
								</el-result>
							</div>
						</div>
					</div>
				</div>

				<!-- 网上申办 -->
				<div class="center-container-right" v-if="pages=='3'">
					<div class="center-container-right-title">
						<span class="title">网上申办</span>
					</div>
					<div class="center-container-right-words">
						<div class="people-pic">
							<div class="form_box">
								<div>
									<el-row :gutter="15">
										<div v-if="!isinform">
											<div style="height: 600px;line-height: 30px;padding: 20px 30px;overflow: scroll; ">
												公证申请人：</br>
												依据《公证法》第二十七条第二款的规定，现将你申办公证的法律意义、法律后果以及申办公证的注意事项告知如下：</br>
												1．在办理公证过程中，本处工作人员会以下列方式（之一或者全部）搜集和固定你对申请公证的事项进行陈述、确认的证明材料：</br>
												  （1）请你在相关的文件上签字；</br>
												  （2）请你在相关的文件上按指印；</br>
												  （3）提取你的全部指纹；</br>
												  （4）对你办理公证的某些过程进行拍照；</br>
												  （5）对你办理公证的某些过程进行录像；</br>
												  （6）对你办理公证的某些过程进行录音。</br>
												本处将上述证明材料的全部或者部分作为本处出具公证书的依据予以存档。因此，对于需要你在本处签字（按指印）确认的文件，请你在签字（按指印）前务必仔细阅读。如果你存在异议，请勿签字（按指印）。如果你不能阅读，你可以请求公证员向你宣读和解释需要你签字（按指印）确认的全部文件。</br>
												本次申办为网上在线申办，申请人需承诺该公证申请完全出自本人意愿，同意公证处线上办证平台对其身份核验（活体检测）、远程视频核验，保证其电子签名真实且字迹清晰可辨。</br></br>
												2．你的申请被受理后，经过公证员审核，如果发现你所申请的事项存在法律规定的不予办理公证的情形，本处将不予出具公证书。</br>
												3．在申办公证的过程中，你主要享有以下权利：</br>
												  （1）在办证过程中，你对办理公证的相关材料的内容和办理公证的法律意义、法律后果有不清楚之处，你有权要求公证员进行告知和解释；</br>
												  （2）你在询问笔录上签字（按指印）之前，你有权要求公证员修改询问笔录，并对笔录和笔录的修改之处签字（按指印）确认。</br>
												4．在申办公证的过程中，你主要应当承担以下义务：</br>
												你有义务向本处作如实的陈述和提供真实、合法、充分的证明材料。如果你不能作如实陈述以及不能提供真实、合法、充分的证明材料，依据《公证程序规则》第四十八条第（六）项的规定，本处不予办理公证。如果因为你所作的陈述不真实，或者提供的材料虚假，本处有权拒绝出具公证书，或者撤销已经出具的公证书，并有权要求你承担相应的法律责任。</br>
												5．在本处出具公证书后，你认为公证书有错误的，有权在收到公证书之日起一年内，向本公证处提出复查，超过一年复查申请期限的，本处不再受理你的复查申请。</br></br>
												本处特别提示：请你在前面告知书上签字（按指印）之前务必认真阅读本告知书。如果你有疑问或者异议，可以要求本处工作人员作出解答；如果你阅读本告知书有困难，可以要求本处工作人员向你宣读。经你签字确认后，本告知书将存入本处的公证档案，作为你已经知悉本告知书所载明内容，并愿意承担相应义务的证据。
											</div>
											<el-col :span="24" style="text-align: center;margin-top: 20px;">
													<el-button type="danger" @click="inform" >已阅读并同意上述告知</el-button>
											</el-col>
										</div>
										<el-form v-if="isinform" class="demo-ruleForm" ref="form" :model="form" :rules="srules"
											size="medium" label-width="100px">
											<el-col :span="24">
												<el-steps :active="num" simple>
													<el-step title="填写材料" icon="el-icon-edit"></el-step>
													<el-step title="公证申请人" icon="el-icon-user-solid"></el-step>
													<el-step title="上传材料" icon="el-icon-picture"></el-step>
													<el-step title="提交完成" icon="el-icon-success"></el-step>
												</el-steps>
											</el-col>
											<div v-if="num==1">
												<el-col :span="24">
													<el-card class="box-card" style="margin-top: 5px;">
														<div slot="header" class="clearfix">
															<span style="color: red;font-size: 20px;"><i
																	class="el-icon-s-order"></i>基本信息</span>
														</div>
														<el-col :span="12">
															<el-form-item label="公证类别" prop="category">
																<el-select @change="showsx" @visible-change="lbchange"
																	v-model="form.category" placeholder="请选择公证类别"
																	clearable :style="{width: '100%'}">
																	<el-option v-for="(item, index) in lboptions"
																		:key="index" :label="item.value"
																		:value="item.key" :disabled="item.disabled">
																	</el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="12">
															<el-form-item label="公证用途" prop="purpose">
																<el-select v-model="form.purpose" placeholder="请选择公证用途"
																	clearable :style="{width: '100%'}">
																	<el-option v-for="(item, index) in ytoptions"
																		:key="index" :label="item.value"
																		:value="item.key" :disabled="item.disabled">
																	</el-option>
																</el-select>
															</el-form-item>
														</el-col>
														<el-col :span="12">
															<el-form-item label="公证使用地" prop="place">
																<el-select @change="showlang"
																	@visible-change="sbsydchange" v-model="form.place"
																	placeholder="请选择公证使用地" clearable
																	:style="{width: '100%'}">
																	<el-option v-for="(item, index) in sydoptions"
																		:key="index" :label="item.value"
																		:value="item.key" :disabled="item.disabled">
																	</el-option>
																</el-select>
															</el-form-item>
														</el-col>
													</el-card>
												</el-col>
												<el-col :span="24">
													<el-card class="box-card"
														style="margin-top: 5px;min-height: 100px;">
														<div slot="header" class="clearfix">
															<span style="color: red;font-size: 20px;"><i
																	class="el-icon-s-cooperation"></i>公证事项</span>
														</div>
														<el-form-item label="请选择事项:">
															<el-checkbox-group v-model="sxgroup" size="mini">
																<el-checkbox v-for="(item,index) in sxoptions"
																	:label="item">{{item.name}}</el-checkbox>
															</el-checkbox-group>
														</el-form-item>
													</el-card>
												</el-col>
												<el-col :span="24">
													<el-card class="box-card"
														style="margin-top: 5px;min-height: 100px;">
														<div slot="header" class="clearfix">
															<span style="color: red;font-size: 20px;"><i
																	class="el-icon-notebook-2"></i>公证译文</span>
														</div>
														<el-form-item label="请选择译文:" prop="language">
															<el-radio-group v-model="form.language" size="mini">
																<el-radio label="不翻译" value=""></el-radio>
																<el-radio v-for="(item,index) in yzoptions"
																	:label="item.key" :value="item.key">{{item.value}}
																</el-radio>
															</el-radio-group>
														</el-form-item>
													</el-card>
												</el-col>
											</div>

											<div v-if="num==2">
												<el-col :span="24">
													<el-card class="box-card"
														style="margin-top: 5px;min-height: 240px;">
														<div slot="header" class="clearfix">
															<span style="color: red;font-size: 20px;"><i
																	class="el-icon-s-custom"></i>人员信息</span>
														</div>
														<el-col :span="24">
															<el-table class="eltable-box" :data="sxtableData"
																style="width: 100%;">
																<el-table-column align="center" prop="value"
																	label="事项名称" min-width="20%">
																</el-table-column>
																<el-table-column align="center" prop="stepper"
																	label="公证书份数" min-width="20%">
																	<template slot-scope="scope">
																		<el-input-number size="mini"
																			v-model="scope.row.stepper" :min="1"
																			label="份数" @change="changeVal($event)">
																		</el-input-number>
																	</template>
																</el-table-column>
																<el-table-column align="center" prop="translate"
																	label="是否翻译" min-width="10%">
																	<template slot-scope="scope">
																		<el-switch v-model="scope.row.translate"
																			active-color="#FF5A26"
																			inactive-color="#BFBFBF">
																		</el-switch>
																	</template>
																</el-table-column>
																<el-table-column align="center" prop="peopleList"
																	label="申请人" min-width="30%">
																	<template slot-scope="scope">
																		<span
																			v-for="(item,index) in scope.row.peopleList">
																			{{item.name}}
																		</span>
																	</template>
																</el-table-column>
																<el-table-column align="center" label="操作"
																	min-width="20%">
																	<template slot-scope="scope">
																		<el-button style="width: 100%;" size="mini"
																			type="danger" round
																			@click="adduser(scope.row)">添加人员
																		</el-button>
																	</template>
																</el-table-column>
															</el-table>

														</el-col>
													</el-card>
												</el-col>
												<el-dialog title="申请人信息" :visible.sync="open" width="50%"
													:show-close="false">
													<el-button style="width: 15%;" type="danger"
														@click="innerVisible = true">新增人员</el-button>
													<el-button style="width: 15%;" type="warning" @click="choosery">确定选择
													</el-button>
													<el-table class="eltable-box" :data="rytableData"
														style="width: 100%;" @selection-change="handleSelectionChange">
														<el-table-column align="center" type="selection" min-width="5%">
														</el-table-column>
														<el-table-column align="center" prop="name" label="姓名"
															min-width="10%">
														</el-table-column>
														<el-table-column align="center" prop="certificatestype"
															label="证件类型" min-width="15%">
															<template>
																<span>居民身份证</span>
															</template>
														</el-table-column>
														<el-table-column align="center" prop="certificatesnumber"
															label="证件号码" min-width="25%">
														</el-table-column>
														<el-table-column align="center" prop="certificatesaddr"
															label="证件地址" min-width="30%">
														</el-table-column>
														<el-table-column align="center" prop="phone" label="手机号码"
															min-width="15%">
														</el-table-column>
														<el-table-column align="center" label="操作" min-width="10%">
															<template slot-scope="scope">
																<el-link type="primary">修改</el-link>
																<!-- <el-link style="margin-left: 5px;" type="danger">删除
																</el-link> -->
															</template>
														</el-table-column>
													</el-table>

													<el-dialog width="25%" title="新增人员" :visible.sync="innerVisible"
														:show-close="false" append-to-body center="">
														<el-form :model="ryform" :rules="ryrules" ref="ryform"
															label-width="100px" class="demo-ruleForm">
															<el-form-item label="姓名" prop="name">
																<el-input v-model="ryform.name"></el-input>
															</el-form-item>
															<el-form-item label="性别" prop="gender">
																<el-select style="width: 100%;" v-model="ryform.gender"
																	placeholder="请选择">
																	<el-option key="1" label="男" value="1"></el-option>
																	<el-option key="2" label="女" value="2"></el-option>
																</el-select>
															</el-form-item>
															<el-form-item label="证件类型" prop="certificatestype">
																<el-select style="width: 100%;"
																	v-model="ryform.certificatestype" placeholder="请选择">
																	<el-option key="7001" label="居民身份证" value="7001">
																	</el-option>
																</el-select>
															</el-form-item>
															<el-form-item label="证件号码" prop="certificatesnumber">
																<el-input v-model="ryform.certificatesnumber">
																</el-input>
															</el-form-item>
															<el-form-item label="证件地址" prop="certificatesaddr">
																<el-input v-model="ryform.certificatesaddr"></el-input>
															</el-form-item>
															<el-form-item label="手机号码" prop="phone">
																<el-input v-model="ryform.phone"></el-input>
															</el-form-item>
															<div class="elbutbox">
																<el-button style="20%" @click="rysubmit" type="primary">
																	保存</el-button>
															</div>
														</el-form>
													</el-dialog>
												</el-dialog>
											</div>


											<div v-if="num==3">
												<el-col :span="24">
													<el-card class="box-card"
														style="margin-top: 5px;min-height: 280px;">
														<div slot="header" class="clearfix">
															<span style="color: red;font-size: 20px;"><i
																	class="el-icon-picture"></i>上传材料</span>
														</div>
														<el-col :span="24">

															<div style="margin-bottom:20px"
																v-for="(item,index) in materiallist">
																<div
																	style="color: #FF5A26; font-size: 16px;padding: 10px 0px;">
																	*{{item.name}}<span
																		v-if="item.isMust == 'true'">(必传项)</span></div>
																<el-upload ref="uploads" :action="url" :data="item"
																	@click.native="uploadclick(item)"
																	:on-success="uoloadsuccess"
																	list-type="picture-card">
																	<i class="el-icon-plus"></i>
																</el-upload>
															</div>

														</el-col>
													</el-card>
												</el-col>
											</div>

											<div v-if="num==4">
												<el-col :span="24">
													<el-card class="box-card"
														style="margin-top: 5px;min-height: 280px;">
														<el-col :span="24">
															<el-result icon="success" title="提交成功"
																subTitle="您的公证申请已成功提交,请耐心等待公证员审核">
															</el-result>
														</el-col>
													</el-card>
												</el-col>
											</div>

											<el-col :span="24" v-if="num < 4">
												<el-form-item size="large" style="text-align: center;margin-top: 30px;">
													<el-button type="info" @click="Back">上一步</el-button>
													<el-button type="danger" @click="Next">下一步</el-button>
												</el-form-item>
											</el-col>
										</el-form>
									</el-row>
								</div>
							</div>
						</div>
					</div>
				</div>


			</div>
		</div>
		<!--底部导航-->
		<bottominfo></bottominfo>
	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {
		category,
		purpose,
		place,
		matter,
		setAppointment,
		language,
		setInfo,
		setWebConsulting,
		registerUser,
		getUserList,
		setMatter,
		material,
		setWebMaterial,
		sbsubmit
	} from '../api/indexapp.js'
	export default {
		name: "Personnel",
		components: {
			headinfo,
			bottominfo,
		},
		metaInfo: {
			title: '网上服务-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '网上服务'
			}],
		},
		data() {
			return {
				isinform:false,
				islogins:false,
				show1:true,
				show2:true,
				url: "/cxWebAppApi/common/hcupload",
				materiallist: [],
				sxbh: '',
				yxzry: [],
				ryform: {
					certificatesaddr: null,
					certificatesnumber: null,
					certificatestype: null,
					gender: null,
					isself: false,
					name: null,
					phone: null,
					usertype: "1"
				},
				ryrules: {
					certificatestype: [{
						required: true,
						message: '请选择证件类型',
						trigger: 'blur'
					}],
					certificatesnumber: [{
						required: true,
						message: '请输入证件号码',
						trigger: 'blur'
					}, {
						min: 15,
						max: 18,
						message: '证件号码长度不符合规范',
						trigger: 'blur'
					}],
					certificatesaddr: [{
						required: true,
						message: '请输入证件地址',
						trigger: 'blur'
					}],
					gender: [{
						required: true,
						message: '请选择性别',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入该申请人手机号码',
						trigger: 'blur'
					}, {
						min: 11,
						max: 11,
						message: '手机号码长度不符合规范',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入您的姓名',
						trigger: 'blur'
					}, {
						min: 2,
						message: '姓名长度不符合规范',
						trigger: 'blur'
					}],
				},
				innerVisible: false,
				active: 1,
				num: 1,
				nums: 1,
				sxgroup: [],
				sxtableData: [],
				rytableData: [{
					name: '王小虎',
					zjlx: '居民身份证',
					zjhm: '33333333333333333',
					phone: '13011002233',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					name: '王大虎',
					zjlx: '居民身份证',
					zjhm: '33333333333333333',
					phone: '13011002233',
					address: '上海市普陀区金沙江路 1518 弄'
				}],
				open: false,
				tabledata: null,
				hoturl: '/cxWebApi/profile',
				info: null,
				lboptions: [],
				ytoptions: [],
				sydoptions: [],
				sxoptions: [],
				yzoptions: [],
				ruleForm: {
					name: null,
					phone: null,
					content: null,
					ispublic: true,
				},
				rules: {
					name: [{
						required: true,
						message: '请输入您的姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入您的手机号码',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入您的咨询内容',
						trigger: 'blur'
					}],
				},
				yruleForm: {
					category: null,
					matter: null,
					purpose: null,
					place: null,
					appointmentdate: null,
					name: null,
					phone: null,
					content: null,
				},
				yrules: {
					name: [{
						required: true,
						message: '请输入您的姓名',
						trigger: 'blur'
					}, {
						min: 2,
						message: '姓名长度不符合规范',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入您的手机号码',
						trigger: 'blur'
					}, {
						min: 11,
						max: 11,
						message: '手机号码长度不符合规范',
						trigger: 'blur'
					}],
					appointmentdate: [{
						required: true,
						message: '请选择预约时间',
						trigger: 'blur'
					}],
					category: [{
						required: true,
						message: '请选择公证类别',
						trigger: 'blur'
					}],
					matter: [{
						required: true,
						message: '请选择公证事项',
						trigger: 'blur'
					}],
					purpose: [{
						required: true,
						message: '请选择公证用途',
						trigger: 'blur'
					}],
					place: [{
						required: true,
						message: '请选择使用地',
						trigger: 'blur'
					}],
				},
				pages: '1',
				form: {
					category: null, //类别
					purpose: null, //用途
					place: null, //使用地
					language: null, //语种
					matter: [],
				},
				srules: {
					category: [{
						required: true,
						message: '请选择公证类别',
						trigger: 'blur'
					}],
					matter: [{
						required: true,
						message: '请选择公证事项',
						trigger: 'blur'
					}],
					purpose: [{
						required: true,
						message: '请选择公证用途',
						trigger: 'blur'
					}],
					place: [{
						required: true,
						message: '请选择使用地',
						trigger: 'blur'
					}],
					language: [{
						required: true,
						message: '请选择是否翻译',
						trigger: 'blur'
					}]
				},
				uploadrow: null,
				uploadlist:[],
			}
		},
		created() {
			this.pages = this.$route.params.page;


		},
		methods: {
			inform(){
				let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				if(obj==null){
					this.islogins = true
				}else{
					this.isinform = true
					this.getcategory();
					this.getpurpose();
				}
			},
			onclose(){
				this.islogins = false;
			},
			uploadclick(item) {
				this.uploadrow = item;
			},
			uoloadsuccess(response, file, fileList) {
				let obj = {
					detailId: this.uploadrow.detailId,
					name: this.uploadrow.name,
					path: response.filePath,
					type: response.fileType
				}
				this.uploadlist.push(obj)
			},
			choosery() {
				this.sxtableData.forEach((item, index) => {
					if (item.key == this.sxbh) {
						this.sxtableData[index].peopleList = this.yxzry;
						this.open = false;
					}
				})
			},
			handleSelectionChange(val) {
				this.yxzry = val;
			},
			rysubmit() {
				this.$refs['ryform'].validate((valid) => {
					if (valid) {
						registerUser(this.ryform).then(res => {
							if (res.code == 200) {
								this.$alert('增加人员成功', '提交成功', {
									confirmButtonText: '确定',
									showClose: false,
									callback: action => {
										this.ryform = {}
										this.innerVisible = false;
										// 刷新列表
										getUserList().then(res => {
											this.rytableData = res.data
										})
									}
								});
							} else {
								this.$message.error('新增失败，请重新提交！');
							}
						})
					}
				})
			},
			sendsetWebConsulting() {
				let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				this.$refs['ruleForm'].validate((valid) => {
					if(obj==null){
						
						this.islogins = true
					}else{
							if (valid) {
								setWebConsulting(this.ruleForm).then(res => {
									if (res.code == 200) {
										this.show1 = false;
									} else {
										this.$message.error('提交失败，请重新提交！');
									}
								})
							}
					}
					
				})
			},
			showsx() {
				this.sxoptions = []
				// 获取事项
				matter({
					category: this.form.category
				}).then(res => {
					res.data.forEach(item => {
						item.products.forEach(i => {
							this.sxoptions.push(i)
						})
					})
				})
			},
			showlang() {
				// 获取语种
				language({
					country: this.form.place
				}).then(res => {
					this.yzoptions = res.data
				})
			},
			changeVal() {
				this.$forceUpdate();
			},
			sxchange() {
				if (this.yruleForm.category == null) {
					this.$message.error('请先选择公证类别！');
				} else {
					this.sxoptions = [];
					matter({
						category: this.yruleForm.category
					}).then(res => {
						res.data.forEach(item => {
							item.products.forEach(i => {
								this.sxoptions.push(i)
							})
						})
					})
				}
			},
			lbchange() {
				this.sydoptions = [];
				this.yruleForm.place = null;
				this.form.place = null;
			},
			sbsydchange() {
				if (this.form.category == null) {
					this.$message.error('请先选择公证类别！');
				} else {
					this.sydoptions = [];
					place({
						category: this.form.category
					}).then(res => {
						res.data.countrieslist.forEach((item, index) => {
							item.countries.forEach((idx, inx) => {
								this.sydoptions.push(idx)
							})
						})
					})
				}
			},
			sydchange() {
				if (this.yruleForm.category == null) {
					this.$message.error('请先选择公证类别！');
				} else {
					this.sydoptions = [];
					place({
						category: this.yruleForm.category
					}).then(res => {
						res.data.countrieslist.forEach((item, index) => {
							item.countries.forEach((idx, inx) => {
								this.sydoptions.push(idx)
							})
						})
					})
				}
			},
			show(row) {
				this.pages = row;
			},
			Next() {
				if (this.num == 1) {
					this.$refs['form'].validate((valid) => {
						if (valid) {
							if (this.sxgroup.length == 0) {
								this.$message.error('请选择事项！');
							} else {
								setInfo(this.form).then(res => {
									if (res.code == 200) {
										this.sxgroup.forEach(item => {
											let obj = {
												value: item.name,
												key: item.key,
												stepper: '1',
												translate: false,
												peopleList: []
											}
											this.sxtableData.push(obj)
										})
										this.nexts();
									} else {
										this.$message.error(res.msg)
									}
								})
							}
						}
					})
				} else if (this.num == 2) {
					let arr = [];
					this.sxtableData.forEach(item => {
						if (item.peopleList == 0) {
							arr.push(1);
						}
					})
					if (arr.length > 0) {
						this.$message.error('请先添加人员！');
						return;
					} else {
						setMatter({
							matter: this.sxtableData
						}).then(res => {
							if (res.code == 200) {
								material().then(res => {
									this.materiallist = res.data
								})
								this.nexts();
							} else {
								this.$message.error(res.msg)
							}
						})
					}
				}else if(this.num == 3){
					if(this.uploadlist.length == 0){
						this.$message.error('请上传材料！')
					}else{
						setWebMaterial({
							material:this.uploadlist
						}).then(res=>{
							if(res.code == 200){
								sbsubmit().then(res=>{
									if(res.code == 200){
										this.nexts();
									}else{
										this.$message.error('提交失败，请重新提交!');
									}
								})
							}else{
								this.$message.error('提交失败，请重新提交');
							}
						})
					}
				}
			},
			nexts() {
				if (this.num < 4) {
					this.num += 1;
				}
			},
			Back() {
				if (this.num > 1) {
					this.num -= 1;
				}
				if (this.num == 1) {
					// this.sxgroup = [];
					this.sxtableData = [];
				}
			},

			adduser(row) {
				this.sxbh = row.key;
				getUserList().then(res => {
					this.rytableData = res.data
					this.open = true;
				})
			},
			getcategory() {
				category().then(res => {
					this.lboptions = res.data
				})
			},
			getpurpose() {
				purpose().then(res => {
					this.ytoptions = res.data
				})
			},
			addyy(formName) {
				// 验证
				this.$refs[formName].validate((valid) => {
					if (valid) {
						setAppointment(this.yruleForm).then(res => {
							if (res.code == 200) {
								this.show2 = false;
							} else {
								this.$message.error('提交失败，请重新提交！');
							}
						})
					}
				})
			}
		},
		// 监听路由
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.pages = val.params.page;
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style scoped>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";

	>>>.ryjjdialog {
		min-height: 650px !important;
		border-radius: 10px;
	}

	>>>.ryjjdialog .el-dialog__header {
		padding: 0px !important;
	}

	>>>.ryjjdialog .el-dialog__body {
		padding: 0px !important;
	}

	>>>.demo-ruleForm label {
		margin: 0 !important;
	}

	>>>.el-input__icon {
		height: auto !important;
	}

	>>>.el-select__tags {
		top: 35% !important;
	}

	>>>.form_box {
		padding: 40px 30px;
	}

	>>>.eltable-box .cell {
		padding-left: 0px !important;
	}

	>>>.eltable-box .el-checkbox {
		/* width: 40px !important; */
	}

	>>>.el-checkbox-group .el-checkbox {
		width: 135px;
	}

	>>>.el-step__icon-inner {
		color: red;
	}

	>>>.el-step__title.is-finish {
		color: red;
	}

	>>>.el-table .el-table__cell {
		padding: 0px !important;
	}

	>>>.el-input-number--mini {
		margin-top: 15px !important;
	}

	>>>.el-checkbox {
		text-align: left !important;
	}

	.lbale-box-list {
		display: flex;
		justify-content: space-between;
	}

	>>>.el-radio {
		width: 80px !important;
	}

	>>>.el-radio__input.is-checked+.el-radio__label {
		color: indianred !important;
	}

	>>>.el-radio__input.is-checked .el-radio__inner {
		border-color: indianred !important;
		background: indianred !important;
	}

	>>>.el-checkbox__input.is-checked+.el-checkbox__label {
		color: indianred !important;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: indianred !important;
		background: indianred !important;
	}

	>>>.el-input__inner {
		text-align: left;
	}

	>>>.el-table tr {
		height: 40px !important;
	}

	>>>.elbutbox {
		width: 100%;
		align-items: center;
		text-align: center;
	}
</style>
